/** "Find players" (review 0020), apart so each language file stays within its budget. */
export const matchEn = {
  "match.searching": "Finding players for {game}",
  "match.waiting": "In the queue: {count} · {time}",
  "match.unreachable": "Cannot reach the server · still trying",
  "match.stop": "Stop searching",
  "match.find": "Find players",
  "match.seatsOpen.short": "Finding players · standard settings",
  "match.anywhere.short": "From different voice channels",
  "match.stalled.short": "Nobody new for a minute",
  "match.standard": "Standard settings: {target} · {tempo}",
  "match.seatsOpen":
    "Finding players for the empty seats, on standard settings. They may join from other voice channels.",
  "match.hint": "Four players start a table. After a minute, whoever is waiting plays together.",
  "match.anywhere": "Players from different voice channels: you cannot hear each other.",
  "match.stalled": "Nobody new for a minute. Fill the empty seats with bots?",
  "error.queue-table": "A matched table plays its game's standard settings.",
} as const;

export const matchAr: Record<keyof typeof matchEn, string> = {
  "match.searching": "البحث عن لاعبين في {game}",
  "match.waiting": "في الانتظار: {count} · {time}",
  "match.unreachable": "تعذّر الوصول إلى الخادم · ما زلنا نحاول",
  "match.stop": "أوقف البحث",
  "match.find": "ابحث عن لاعبين",
  "match.standard": "الإعدادات القياسية: {target} · {tempo}",
  "match.seatsOpen.short": "البحث عن لاعبين · إعدادات قياسية",
  "match.anywhere.short": "من قنوات صوتية مختلفة",
  "match.stalled.short": "لم يأتِ أحد منذ دقيقة",
  "match.seatsOpen":
    "البحث عن لاعبين للمقاعد الفارغة بالإعدادات القياسية. قد ينضمون من قنوات صوتية أخرى.",
  "match.hint": "تبدأ الطاولة بأربعة لاعبين. بعد دقيقة يلعب المنتظرون معًا.",
  "match.anywhere": "لاعبون من قنوات صوتية مختلفة: لا تسمعون بعضكم.",
  "match.stalled": "لم يأتِ أحد منذ دقيقة. هل تملأ المقاعد الفارغة بالبوتات؟",
  "error.queue-table": "طاولة المطابقة تلعب بالإعدادات القياسية للعبة.",
};

export const matchTr: Record<keyof typeof matchEn, string> = {
  "match.searching": "{game} için rakip aranıyor",
  "match.waiting": "Kuyrukta: {count} · {time}",
  "match.unreachable": "Sunucuya ulaşılamıyor · yeniden deneniyor",
  "match.stop": "Aramayı bırak",
  "match.find": "Rakip ara",
  "match.seatsOpen.short": "Rakip aranıyor · standart ayarlar",
  "match.anywhere.short": "Farklı ses kanallarındasınız",
  "match.stalled.short": "Bir dakikadır kimse gelmedi",
  "match.standard": "Standart ayarlar: {target} · {tempo}",
  "match.seatsOpen":
    "Boş koltuklar için rakip aranıyor, standart ayarlarla. Gelenler farklı ses kanallarından olabilir.",
  "match.hint": "Dört kişi olunca masa kurulur. Bir dakika sonra bekleyenler birlikte oynar.",
  "match.anywhere": "Farklı ses kanallarındasınız: birbirinizi duyamazsınız.",
  "match.stalled": "Bir dakikadır kimse gelmedi. Boş koltukları botla doldurmak ister misin?",
  "error.queue-table": "Eşleşme masasında oyunun standart ayarları geçerli.",
};
